<template>
    <div>
        <img class="icon-bread" :src="Location"/>
        <span class="link" v-for="(route,index) in routeInfo" :key="index">
            <i v-if="index!=0">&gt;</i>
            <router-link :to="route.path">{{route.name}}</router-link> 
            
        </span>
    </div>
</template>
<script>
import Location from '@/assets/images/icon-location.png';
import {mapState} from 'vuex'
export default {
    data(){
        return {
            Location: Location
        }
    },
    computed: {
      ...mapState(['routeInfo'])
    }
}
</script>
<style>
.icon-bread{
    width: 18px;
    height: 20px;
    vertical-align: top;
    margin-right: 10px;
}
.link a{
    color: #333130;
    font-size: 18px;
    line-height: 20px;
}
.link:last-child a{
    color: #ae1e10;
}
</style>
